const KEYS = [
  'title',
  'partitioning',
  'entry_method'
] as string[];

export default function() {
  return KEYS;
}
